{
  "title": "Wall of Sand",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a handful of sand)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You conjure up a wall of swirling sand on the ground at a point you can see within range. You can make the wall up to 30 feet long, 10 feet high, and 10 feet thick, and it vanishes when the spell ends. It blocks line of sight but not movement. A creature is blinded while in the wall’s space and must spend 3 feet of movement for every 1 foot it moves there."
  ],
  "spellLists": ["eldritch-knight", "wizard"]
}
